/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

define ([
    "underscore",
    "service/channels"
  ], function (
    _,
    Channels
  ) {
    
    // TODO: Move to computed model and generalize for all services
  var ConstrainedChannels = Channels.extend({

    initialize: function(attrs, options) {
      Channels.prototype.initialize.apply(this, arguments);
      options = options || {};
      this.requestTransformers = options.requestTransformers || [];
    },

    // set global constraint on all calls
    setConstraint: function(constraint) {
      this.constraint = constraint;
    },

    getConstraint: function() {
      return this.constraint;
    },

    // set global constraint on all calls
    setACLConstraint: function(constraint) {
      this.aclConstraint = constraint;
    },

    getACLConstraint: function() {
      return this.aclConstraint;
    },
    
    prepareRequest: function(channel, request) {
      
      try {
        for (var i = 0; i < this.requestTransformers.length; ++i) {
          request = this.requestTransformers[i](channel, request, {path: request.path});     
          
        }
      } catch (e) {
        if (console && console.warn)
          console.warn("Failed to transform request: ", e);
      }

      if (this.constraint) {
        if (!request.source_context) {
          request.source_context = {};
        }
        
        var constraint = this.constraint; 
        request.source_context.constraints = request.source_context.constraints || [];
        request.source_context.constraints.push(constraint);
      }

      if (this.aclConstraint) {
        if (!request.source_context) {
          request.source_context = {};
        }
        
        var constraint = this.aclConstraint; 
        request.source_context.constraints = request.source_context.constraints || [];
        request.source_context.constraints.push(constraint);
      }

      return Channels.prototype.prepareRequest.apply(this, arguments);
    }
  });

  return ConstrainedChannels;
});
